import clsx from 'clsx'

import type { StatusDoDownload } from '@/hooks/use-bandeja-de-downloads'

import classes from './styles.module.scss'
import type { ItemDaBandejaProps } from './types'

interface ConfiguracaoDoStatus {
  texto: string
  icone?: string
}

const CONFIGURACAO_POR_STATUS: Record<StatusDoDownload, ConfiguracaoDoStatus> =
  {
    'na-fila': { texto: 'Na fila', icone: 'fa-regular fa-clock' },
    baixando: { texto: 'Baixando...' },
    comprimindo: { texto: 'Comprimindo e baixando...' },
    concluido: {
      texto: 'Download concluído',
      icone: 'fa-regular fa-circle-check',
    },
    erro: {
      texto: 'O download falhou',
      icone: 'fa-regular fa-circle-exclamation',
    },
  }

export function ItemDaBandeja({
  item,
  aoSolicitarCancelamento,
}: ItemDaBandejaProps): JSX.Element {
  const { texto, icone } = CONFIGURACAO_POR_STATUS[item.status]
  const emAndamento =
    item.status === 'baixando' || item.status === 'comprimindo'
  const finalizado = item.status === 'concluido' || item.status === 'erro'
  const podeCancelar = emAndamento || item.status === 'na-fila'
  const podeTentarNovamente =
    item.status === 'erro' && Boolean(item.aoTentarNovamente)

  return (
    <li className={clsx(classes.item, classes[item.status])}>
      <div className={classes.cabecalho}>
        <span className={classes.titulo} title={item.titulo}>
          {item.titulo}
        </span>

        {icone && (
          <i className={clsx(classes.icone, icone)} aria-hidden="true" />
        )}
      </div>

      <div
        className={clsx(
          classes.barra,
          emAndamento && classes.indeterminada,
          finalizado && classes.completa
        )}
        role="progressbar"
        aria-label={`Progresso de ${item.titulo}`}
        aria-busy={emAndamento}
      >
        <span className={classes.preenchimento} />
      </div>

      <div className={classes.rodape}>
        <span className={classes.status}>{texto}</span>

        {podeCancelar && (
          <button
            type="button"
            className={classes.acao}
            onClick={() => aoSolicitarCancelamento(item)}
            aria-label={`Cancelar download de ${item.titulo}`}
          >
            Cancelar
          </button>
        )}

        {podeTentarNovamente && (
          <button
            type="button"
            className={classes.acao}
            onClick={item.aoTentarNovamente}
            aria-label={`Tentar novamente o download de ${item.titulo}`}
          >
            Tentar novamente
          </button>
        )}
      </div>
    </li>
  )
}
